export default __webpack_public_path__ + "static/media/situation-mention-role-assign.fe88f6d9.gif";